/**
 * 基本url
 * @type {string}
 */
// export const BASE_URL = '/api1'
export const BASE_URL = 'https://api.daizp.cn'
/**
 * 返回状态：成功
 * @type {number}
 */
export const SUCCUSS = 1;
/**
 * 返回状态：未登录
 */
export const UNLOGIN = 401;



// WEBPACK FOOTER //
// ./src/constant/HttpResp.js